import { DictionaryObject } from '@cawita/core-front';
import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '@shared/modules/crud';
import { Document } from './document.model';
import { Partner } from './partner.model';

export interface EnjoymentDocument extends Document {
    _id?: string,
    name?: string,
}

@CwtModel({ name: 'enjoyment', path: '/enjoyment' })
export class Enjoyment extends ApiData {
    _id?: string
    partners: Partner[]
    name: { fr: string, en: string }
    subtitle: DictionaryObject
    description: DictionaryObject
    isActive: boolean
    isDisplayedInline: boolean
    url: { name: DictionaryObject, value: string }
    picture: Document;
    pictures?: Document[];
    documents: EnjoymentDocument[]
}
